export default __webpack_public_path__ + "static/media/newblp_calendar_sel.fdb1be15.svg";